module.exports = __webpack_public_path__ + "static/media/customers8.975e8382.png";